import { Component, OnInit, Input, Inject, LOCALE_ID } from '@angular/core';

/**
 * Component per mostrar el marcador d'una càmera
 */
@Component({
  selector: 'app-camera',
  templateUrl: './camera.component.html',
  styleUrls: ['./camera.component.css']
})
export class CameraComponent implements OnInit {

  /**
   * Feature que conté les propietats per crear el marcador
   */
  @Input() feature;

  /**
   * Capa a la qual pertany el marcador
   */
  @Input() layer;

  /**
   * Conté les propietats del feature
   */
  properties; 

  /**
   * Url de la icona a mostrar
   */
  iconUrl: string;

  /**
   * Localització de la càmera
   */
  location: string;
  
  /**
   * URL de la imatge de la càmera
   */
  image: string;

  /**
   * Font d'informació 
   */
  source: string;

  /**
   * Text per compartir marcador
   */
  shareText: string; 

  /**
   * Constructor del component
   * @param {string} localeId indica l'idioma actual de la pàgina 
   */
  constructor(@Inject(LOCALE_ID) protected localeId: string) { }

  /**
   * Retorna el text per compartir el marcador
   * @returns {string} text per compartir el marcador
   */
  generateShareText(): string{
    var titol;
    if(this.localeId === 'es') titol = 'Cámara%20de%20tráfico'
    else titol = 'Càmera%20de%20trànsit';

    return titol + ':%20' + this.location + "%20";
  }

  /**
   * Retorna la url que mostra el mapa centrat en el marcador
   * @returns {string} url que mostra el mapa centrat en el marcador
   */
  generateShareUrl(): string{
    var baseUrl = window.location.protocol + "//" + window.location.hostname + ":" + window.location.port + '/infotransit';
    var params = "/%3Flat%3D" + this.feature.geometry.coordinates[1]
                  + "%26lng%3D" + this.feature.geometry.coordinates[0]
                  + "%26zoom%3D" + "15"
                  + "%26layers%3D" + this.layer;
    return baseUrl + params;
  }

  /**
   * inicialitza les propietats del component
   */
  ngOnInit() {

    this.properties = this.feature.properties;
    this.iconUrl = 'assets/img/' + this.layer + '_MARKER.svg';

    this.location = this.properties.location;
    this.image = this.properties.image;
    this.source = this.properties.source;

  }

}
